import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { DARK_TEXT_COLOR } from "../../../theme/theme";
import { IIconProps } from "../icon";

export const ArrowRightIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 24 24" version="1.1" {...rest}>
      <title>{t("icons.next")}</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Overrides/Icons/Disclosure-Right" stroke={color ?? DARK_TEXT_COLOR} strokeWidth="2">
          <polyline id="Path-2" points="8.5 4.5 16.5 11.5038631 8.50882514 18.5"></polyline>
        </g>
      </g>
    </svg>
  );
};
